<template>
  <span>
    <v-autocomplete
      v-model="fieldValues"
      :items="items"
      :multiple="isMultiple ? true : false"
      chips
      :label="$t(`component.baseAutocompleteFilter.${label}`)"
      item-value="id"
      item-text="label"
      :filter="customAutocompleteFilter"
      @change="search"
      @click:clear="clear"
      clearable
      :menu-props="{ closeOnContentClick: true, maxWidth: 'min-content' }"
    >
      <template v-slot:selection="data">
        <v-chip
          :input-value="data.selected"
          class="chip--select"
          small
          :close="isMultiple ? true : false"
          color="primary"
          text-color="white"
          @update:active="removeSelected(data.item)"
          ><span class="font-weight-bold">{{ data.item.label }}</span></v-chip
        >
      </template>
      <template v-slot:item="data">
        <template v-if="data.item.constructor.name !== 'Object'">
          <v-list-item-content>
            <span>{{ data.item }}</span>
          </v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-content>
            <v-list-item-title
              ><span v-html="data.item.label"></span
            ></v-list-item-title>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    },
    label: {
      type: String,
      required: true
    },
    isMultiple: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {};
  },
  computed: {
    fieldValues: {
      get() {
        if (this.isMultiple) {
          return this.value;
        } else {
          return this.value[0];
        }
      },
      set(val) {
        if (this.isMultiple) {
          if (val && val.length > 0) {
            this.$emit("input", val);
          }
        } else {
          if (val && val != null) {
            this.$emit("input", val);
          }
        }
      }
    }
  },
  methods: {
    customAutocompleteFilter(item, queryText /*, itemText*/) {
      const textOne = item.label.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    },
    search(value) {
      if (this.isMultiple) {
        if (value && value.length > 0) {
          this.$emit("onsearch", value);
        }
      } else {
        this.$emit("onsearch", ...[value]);
      }
    },
    clear() {
      this.$emit("onclear", []);
    },
    removeSelected(value) {
      this.$emit("onremoveselected", value);
    }
  }
};
</script>
